import React from 'react';
import CustomPage from './CustomPage';

const AboutPage = () => <CustomPage pageSlugOverride="about" />;

export default AboutPage;

